<template>
  <div class="modal-social-complete">
    <SocialComplete :data="modalsData" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SocialComplete from "@/components/SocialComplete.vue";

export default {
  name: "ModalSocialComplete",
  components: { SocialComplete },
  computed: {
    ...mapGetters(["modalsData"])
  }
};
</script>
